import _styled from "styled-components";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var NonAuthenticatedNav = function NonAuthenticatedNav(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: children
  });
};
export default NonAuthenticatedNav;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "non-authenticated-nav___StyledDiv",
  componentId: "sc-eroy9f-0"
})({
  "display": "none",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1rem",
  "@media (min-width: 768px)": {
    "display": "flex"
  }
});